import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_HOST_URL || 'http://localhost:9091',
    withCredentials: true, // 쿠키를 포함하여 요청
});

// 요청 인터셉터
apiClient.interceptors.request.use(config => {
  const token = sessionStorage.getItem('avatye:ops:admin:accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 응답 인터셉터 (Access 만료 → Refresh → 재시도)
apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes('/auth/refresh')) {
      originalRequest._retry = true;

      try {
        const res = await apiClient.post('/api/v1/auth/refresh');
        const newToken = res.data.access_token;

        sessionStorage.setItem('avatye:ops:admin:accessToken', newToken);
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

        return apiClient(originalRequest);
      } catch (refreshError) {
        sessionStorage.removeItem('avatye:ops:admin:accessToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;